import MapSidebar from "./MapSidebar.component";

export default MapSidebar;
